module.exports = __webpack_public_path__ + "static/media/cert_51.9565b0b4.jpg";